import createVueApp from '@phoenix/createVueApp';
import PhxsgCardSlider from '@sg/src/View/Components/Organisms/CardSlider/phxsg-card-slider.vue';
import PhxsgCardSliderSlide from '@sg/src/View/Components/Organisms/CardSlider/phxsg-card-slider-slide.vue';
import { PhxsgCard } from '@sg/src/View/Components/Molecules/Card';

document.querySelectorAll('.phoenix-new-card-slider').forEach((el) => {
  const app = createVueApp({});
  app.component('PhxsgCardSlider', PhxsgCardSlider);
  app.component('PhxsgCardSliderSlide', PhxsgCardSliderSlide);
  app.component('PhxsgCard', PhxsgCard);
  app.mount(el);
});
